import { render, staticRenderFns } from "./PagePaper.vue?vue&type=template&id=7e3a561b&scoped=true&"
import script from "./PagePaper.vue?vue&type=script&lang=js&"
export * from "./PagePaper.vue?vue&type=script&lang=js&"
import style0 from "./PagePaper.vue?vue&type=style&index=0&id=7e3a561b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3a561b",
  null
  
)

export default component.exports